import * as React from "react";
import { Text } from "@nju/ui";

interface ICopy {
  numberVariant: "failed" | "success" | undefined;
}

export function PortalCopy({ numberVariant }: ICopy) {
  return (
    <Text className="mt-8 only-mobile:mt-5" display="block">
      {numberVariant === "failed"
        ? "Z tym numerem się nie udało - przejdź dalej i zdecyduj, co chcesz zrobić za ten numer."
        : "Już wiemy, co chcesz zrobić z poprzednim numerem. Teraz przejdźmy do kolejnego."}
    </Text>
  );
}
